import React from 'react';
import { StyledCardCvcElement } from './styles';
import { t } from 'i18next';
import { Colors } from 'goalsetter-webapp-components';

interface StripeCardCvcInputProps {
  cardCvcError: string;
  handleCardCvcChange: (event: {
    error:
      | { type: 'validation_error'; code: string; message: string }
      | undefined;
  }) => void;
  handleCardCvcOnBlur: () => void;
}

export const StripeCardCvcInput: React.FC<StripeCardCvcInputProps> = ({
  cardCvcError,
  handleCardCvcChange,
  handleCardCvcOnBlur,
}) => {
  return (
    <StyledCardCvcElement
      hasError={!!cardCvcError}
      onChange={handleCardCvcChange}
      onBlur={handleCardCvcOnBlur}
      options={{
        placeholder: String(t('purchase.formInputs.cvc.placeholder')),
        style: {
          base: {
            fontFamily: 'Avenir',
            fontSize: '16px',
            fontWeight: 500,
            lineHeight: '48px',
            fontSmoothing: 'antialiased',
            padding: '12px',
            '::placeholder': {
              color: Colors.MEDIUM_EMPHASIS,
            },
          },
          invalid: {
            color: Colors.HIGH_EMPHASIS,
          },
        },
      }}
    />
  );
};
